import AuthHOC from "../hoc/AuthHOC";
import { isLoggedIn } from "../functions/authSession";

const PublicAndPrivate = page => {
  return isLoggedIn() ? AuthHOC(page) : page;
};

export default PublicAndPrivate;
